module.exports = __webpack_public_path__ + "static/media/bed_icon.9fa332b8.svg";